declare var ol: any;

export interface PolygonState {
  coordinates: number[][];
  timestamp: number;
}

export class HistoryManager {
  private history: PolygonState[] = [];
  private maxHistorySize = 50;
  private _canUndo = false;

  constructor(
    private getVectorSource: () => any,
    private onUndoStateChange: (canUndo: boolean) => void
  ) {}

  get canUndo(): boolean {
    return this._canUndo;
  }

  /**
   * Sauvegarde l'état actuel du polygone dans l'historique
   */
  saveState(feature: any): void {
    if (!feature) return;

    const geometry = feature.getGeometry();
    if (!geometry || geometry.getType() !== 'Polygon') return;

    const coords = geometry.getCoordinates()[0];

    // Clone les coordonnées pour éviter les références
    const clonedCoords = coords.map((coord: number[]) => [...coord]);

    const state: PolygonState = {
      coordinates: clonedCoords,
      timestamp: Date.now()
    };

    this.history.push(state);

    // Limiter la taille de l'historique
    if (this.history.length > this.maxHistorySize) {
      this.history.shift();
    }

    this.updateUndoState();
  }

  /**
   * Restaure l'état précédent du polygone (Ctrl+Z)
   */
  undo(): boolean {
    if (this.history.length < 2) {
      return false;
    }

    // Retirer l'état actuel
    this.history.pop();

    // Récupérer l'état précédent
    const previousState = this.history[this.history.length - 1];
    if (!previousState) return false;

    const vectorSource = this.getVectorSource();
    if (!vectorSource) return false;

    // Trouver le polygone actuel
    const polygonFeatures = vectorSource.getFeatures()
      .filter((f: any) => f.getGeometry()?.getType() === 'Polygon' && f.get('type') !== 'parentPolygon' && f.get('type') !== 'siblingPolygon');

    if (polygonFeatures.length === 0) return false;

    const feature = polygonFeatures[0];
    const geometry = feature.getGeometry();

    // Restaurer les coordonnées
    geometry.setCoordinates([previousState.coordinates]);

    this.updateUndoState();
    return true;
  }

  /**
   * Efface tout l'historique
   */
  clear(): void {
    this.history = [];
    this.updateUndoState();
  }

  /**
   * Récupère le nombre d'états dans l'historique
   */
  getHistoryLength(): number {
    return this.history.length;
  }

  private updateUndoState(): void {
    const newCanUndo = this.history.length > 1;
    if (this._canUndo !== newCanUndo) {
      this._canUndo = newCanUndo;
      this.onUndoStateChange(this._canUndo);
    }
  }
}

